import { useTranslation } from 'react-i18next'

import { useSuspenseAtendimento } from '@/features/atendimento/chile/hooks/use-suspense-atendimento'
import { IdentificadorClienteAtendimento } from '@/features/atendimento/shared/components/identificador-cliente-atendimento'
import type { TClienteChile } from '@/types/atendimento'
import { getEstadoCivilKeyMap } from '@/utils/key-map'
import { Rut } from '@/utils/rut'

const ClienteInfo = ({ label, value }: { label: string; value: string | null }) => {
  const { t } = useTranslation('atendimento')
  return (
    <div aria-label={label}>
      <span className="font-medium">{label}:</span> {value ?? t('components.atendimento_info.nao_informado')}
    </div>
  )
}

export const DetalhesClienteAtendimentoChile = () => {
  const { data: atendimento } = useSuspenseAtendimento()
  const { t } = useTranslation('atendimento')

  if (!atendimento || atendimento.cliente === null) return null

  const cliente = atendimento.cliente as TClienteChile
  const rutFormatado = cliente.rut ? new Rut(cliente.rut).format() : null
  const estadoCivilKeyMap = getEstadoCivilKeyMap()

  return (
    <div className="min-w-86 space-y-4 px-3 py-2">
      <div className="flex h-7.5 items-center gap-2">
        <IdentificadorClienteAtendimento nome={cliente.nome} className="size-7.5" />
      </div>
      <div className="font-nunito mb-4 space-y-2 border-b pb-4 text-sm text-neutral-800">
        <ClienteInfo label={t('components.atendimento_info.chaves.rut')} value={rutFormatado} />
        <ClienteInfo label={t('components.atendimento_info.chaves.telefone')} value={cliente.telefone} />
        <ClienteInfo label={t('components.atendimento_info.chaves.profissao')} value={cliente.profissao} />
        <ClienteInfo
          label={t('components.atendimento_info.chaves.estado_civil')}
          value={cliente.estadoCivil ? estadoCivilKeyMap[cliente.estadoCivil] : null}
        />
      </div>
      <div className="font-nunito space-y-2 text-sm text-neutral-800">
        <ClienteInfo
          label={t('components.atendimento_info.chaves.codigo_opp')}
          value={atendimento?.oportunidade?.codigoOportunidade ?? '-'}
        />
        <ClienteInfo
          label={t('components.atendimento_info.chaves.vendedor')}
          value={atendimento?.oportunidade?.proprietario ?? '-'}
        />
      </div>
    </div>
  )
}
